import { render, staticRenderFns } from "./countdowns.page.vue?vue&type=template&id=2282c06e&scoped=true&"
import script from "./countdowns.page.vue?vue&type=script&lang=js&"
export * from "./countdowns.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282c06e",
  null
  
)

export default component.exports